import { BlogService } from "@/services/blog";
import Link from "next/link";
import Image from "next/image";

export default async function BlogCategory() {
  const blogCategoriesList = await BlogService.blogCategoriesList();
  return (
    <section aria-label="Product List">
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {blogCategoriesList.map((bCat) => (
          <article
            key={bCat.category}
            className="bg-background rounded-xl shadow p-6 flex flex-col h-full"
          >
            <Link
              href={`/blog/category/${bCat.category}`}
              className="block group mb-4"
              aria-label={bCat.label}
              prefetch={true}
            >
              <div className="overflow-hidden rounded-lg aspect-video bg-muted">
                <Image
                  src={bCat.image}
                  alt={bCat.label}
                  width={400}
                  height={300}
                  className="w-full h-auto group-hover:scale-105 transition-transform duration-300"
                  priority={false}
                />
              </div>
            </Link>
            <div className="flex-1 flex flex-col">
              <Link href={`/blog/category/${bCat.category}`}>
                <h2 className="text-xl font-semibold mb-2">{bCat.label}</h2>
                <p className="text-foreground/70 mb-2 flex-1">{bCat.descrip}</p>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
